export function getGdsServiceCalculatedCountInfo(passengerId, segmentId, servicesCalculatedLimitInfo, params) {
    var _a, _b, _c, _d;
    const calculatedCountInfo = (_a = servicesCalculatedLimitInfo[passengerId]) === null || _a === void 0 ? void 0 : _a[segmentId];
    if (!calculatedCountInfo) {
        return undefined;
    }
    const { rfisc, subType, type } = params;
    if (rfisc) {
        const byRfisc = (_b = calculatedCountInfo.rfisc) === null || _b === void 0 ? void 0 : _b[rfisc];
        if (byRfisc) {
            return byRfisc;
        }
    }
    if (subType) {
        const bySubType = (_c = calculatedCountInfo.subType) === null || _c === void 0 ? void 0 : _c[subType];
        if (bySubType) {
            return bySubType;
        }
    }
    if (type) {
        const byType = (_d = calculatedCountInfo.type) === null || _d === void 0 ? void 0 : _d[type];
        if (byType) {
            return byType;
        }
    }
    return undefined;
}
